import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PplDialogRef } from '@ppl/ui/dialog';
import type { Space } from '@ppl/graphql-user-api';

@Component({
  selector: 'ppl-space-access-forbidden-dialog',
  templateUrl: './space-access-forbidden-dialog.component.html',
  styleUrls: ['./space-access-forbidden-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SpaceAccessForbiddenDialogComponent {
  space: Space;

  constructor(
    public dialogRef: PplDialogRef<SpaceAccessForbiddenDialogComponent>
  ) { }
}
